<template>
  <div>
    <div class="from-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una Dependencia</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las dependencias</option>  
        <option v-for="(tipoDependencia,index) in tiposDependencia" :value="tipoDependencia.TipoDependenciaId" :key="index">{{tipoDependencia.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
  	data() {
      return {
        enumeraciones,
        tiposDependencia: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods:{
    	cambiarDatos(evento){
	        this.idDelModelo = evento.target.value;
	        const valoresDelCatalogo =
	        {
	          llave: this.idDelInput,
	          valor: evento.target.value 
	        }

	        this.$store.dispatch("A_REGOP_Catalogos_002TiposDependencias",valoresDelCatalogo);
	        this.$emit("valorParaElPadre",evento);    		
    	},
    	cargarTiposDependencia: function(){
    		const SERVIDOR = api.conexion;
        	const METODO_API_AGREGAR = api.REGOP.catalogos.C002TiposDependencias;
        	let urlApi = SERVIDOR + METODO_API_AGREGAR;

        	if(this.parametros == null || this.parametros == undefined)
          		this.parametros = {};
        	
        	this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        	let peticionMetodoGetTiposDependenciasAPI = this.parametros;

        	let peticionArchivos = false;
        	let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        	comun.SeEstaCargandoInformacion(true); 

			axios.post(urlApi, peticionMetodoGetTiposDependenciasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.tiposDependencia = respuesta.data.TiposDependencias;

                    if(this.parametros.elementosAOmitir != undefined){
                    	this.tiposDependencia = this.tiposDependencia.filter(element => {                   
                    		if(!this.parametros.elementosAOmitir.includes(element.TipoDependenciaId))
                    			return element;
                    	});
                    }

                    if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                     	this.tiposDependencia = this.tiposDependencia.filter(element => {                  
                    		if(this.parametros.elementosAConservar.includes(element.TipoDependenciaId))
                    			return element;
                    	});
                    }



                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post         	
    	},
    },
    mounted(){
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_REGOP_Catalogos_002TiposDependencias", valoresDelCatalogo);    	
    },
    created() {
      this.cargarTiposDependencia();
    }
  }

	
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/REGOP/Catalogos/C002TiposDependencias.vue